import React from 'react';
import { bool, node } from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '4px',
    height: '48px',
    minWidth: '160px',
    padding: theme.spacing(0.5, 4),
    boxShadow: 'none',
    background: theme.palette.primary.main,
    [theme.breakpoints.up('md')]: {
      height: '36px',
      minWidth: 'unset',
    },
  },
  // Needs !important because MUI doesn't provide a way to override contained-disabled
  disabled: {
    background: theme.palette.neutral.light,
    color: `${theme.palette.neutral.lightest} !important`,
  },
  loading: {
    background: `${theme.palette.primary.lighter} !important`,
    color: `${theme.palette.neutral.lightest} !important`,
  },
}));

const SquareButton = ({ loading, disabled, children, ...rest }) => {
  const classes = useStyles();
  return (
    <Button
      testid="square-button"
      color="primary"
      variant="contained"
      classes={{
        root: classes.root,
        disabled: loading ? classes.loading : classes.disabled,
      }}
      disabled={loading || disabled}
      endIcon={loading ? <CircularProgress color="inherit" size={16} /> : null}
      {...rest}
    >
      {children}
    </Button>
  );
};

SquareButton.propTypes = {
  loading: bool,
  disabled: bool,
  children: node,
};

SquareButton.defaultProps = {
  loading: false,
  disabled: false,
  children: null,
};

export default SquareButton;
